import React, { useEffect, useState } from "react";
import moment from "moment";

const BlogList = ({ onEdit }) => {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");

  const fetchPosts = () => {
    setLoading(true);
    fetch("https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts")
      .then((response) => response.json())
      .then((data) => {
        setBlogData(data);
        console.log(data, "Blog list");
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const handleDelete = async (postId) => {
    try {
      const response = await fetch(
        `https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts/${postId}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        console.log("Post deleted successfully");
        fetchPosts();
        // Optionally refresh the list or update state
      } else {
        console.error("Failed to delete post");
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const allCategories = [
    "All",
    ...Array.from(
      new Set(blogData.map((blog) => blog.articleCategory || "Uncategorized"))
    ),
  ];

  // Filter blogs based on selectedCategory
  const filteredBlogs =
    selectedCategory === "All"
      ? blogData
      : blogData.filter(
        (blog) =>
          (blog.articleCategory || "Uncategorized") === selectedCategory
      );

  // Group filtered blogs by category
  const groupedBlogs = filteredBlogs.reduce((acc, blog) => {
    const category = blog.articleCategory || "Uncategorized";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(blog);
    return acc;
  }, {});

  if (loading) return <p>Loading...</p>;

  return (
    <div className="blog_dash_wrapper">
      <h2>Resource Library</h2>
      <div
        className="category_menu_scroll"
        style={{
          maxWidth: "100%",
          marginBottom: "45px",
          borderBottom: "1px solid #ccc",
          padding: "0",
        }}
      >
        <div className="category_menu">
          {allCategories.map((category) => (
            <button
              key={category}
              onClick={() => {
                setSelectedCategory(category);
                // window.scrollTo({ top: 700, behavior: "smooth" });
              }}
              className={`category_button ${selectedCategory === category ? "active" : ""
                }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
      <div className="dash_blog_list_wrapper">
        {!loading &&
          Object.entries(groupedBlogs).map(([category, blogs]) => (
            <div key={category} className="category_section">
              {blogs.map((data) => (
                <div className="list_item">
                  <div className="list_content">
                    <div className="img">
                      <img src={data.thumbnailUrl} alt="" />
                    </div>
                    <div className="content">
                      <h2>{data.title}</h2>
                      <p>{moment(data.date).format("MMMM Do YYYY")} </p>
                    </div>
                  </div>
                  <div className="list_action">
                    <button onClick={() => handleDelete(data._id)}>
                      Delete
                    </button>
                    <button onClick={() => onEdit(data)}>Edit</button>
                  </div>
                </div>
              ))}
            </div>
          ))}

      </div>
    </div>
  );
};

export default BlogList;
